<template>
    <div class="app-container">
        
        <el-form :model="formData" :rules="formRules" ref="dataForm" label-width="150px">
            <el-form-item label="治理水域总体量：" prop="name" style="width:800px">
                <el-input v-model="formData.waters" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="百分比(%)：" prop="name" style="width:800px">
                <el-input v-model="formData.percentage" auto-complete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer1">
            <el-button type="primary" @click.native="formSubmit()" :loading="formLoading" style="width:200px">保 存</el-button>
        </div>

    </div>
</template>
<script>
import {apiGovernanceTotal,apiGovernanceTotalSubmit} from "../../api/views/mainData";
export default {
    data() {
        return {
            formData: {
                waters: '',
                percentage:''
            },
            formRules:{
                waters: [{ required: true, message: "请输入维修原因名称", trigger: "blur" }],
                percentage: [{ required: true, message: "请输入维修原因名称", trigger: "blur" }],
            },
            formLoading: false
        }
    },
    mounted() {

    },
    created:function() {
        this.getList()
    },
    methods: {
        getList(){
            apiGovernanceTotal().then(res => {
                this.formData = res
            })
        },
        formSubmit() {
            const that = this, formData = that.formData
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    that.formLoading = true
                    let data = {waters:formData.waters,percentage:formData.percentage}
                    apiGovernanceTotalSubmit(data).then(response => {
                        console.log(response.code)
                        result(response)
                    })
                    function result(response){
                        if (response.code == 0) {
                            that.$message({
                                message: "操作成功",
                                type: "success"
                            });
                            // 刷新表单
                            that.$refs["dataForm"].resetFields();
                            that.formLoading = false
                            that.getList()
                        } else {
                            that.formLoading = false
                            that.$message({
                                message: response.message,
                                type: "error"
                            });
                        }
                    }
                }
            })
        },
    }
}
</script>

<style>
    .app-container{
        padding-top: 50px;
    }
    .dialog-footer1{
        margin-top: 50px;
        width: 800px;
    }
</style>